import styled from 'styled-components'

import TitleCaption from '@/app/components/TitleCaption'
import TitleHeader from '@/app/components/TitleHeader'
import TwitterLink from '@/app/components/TwitterLink'
import { spaces } from '@/config/global-parameters'

import ListVotesPerElectionTable from './ListVotesPerElectionTable'
import { IComparadorElecciones } from './types'

interface IListVotesPerElectionSection {
  circumscriptionId?: string | number
  communeId?: string
  evolucionPorLista?: IComparadorElecciones
}

const ListVotesPerElectionSection = ({
  circumscriptionId,
  communeId,
  evolucionPorLista,
}: IListVotesPerElectionSection) => {
  return (
    <Wrapper>
      <Top>
        <TitleHeader>Votaciones por lista según elección</TitleHeader>
        <TitleCaption>
          Comparador de porcentaje de votos de cada lista con votaciones obtenidas en elecciones
          anteriores
        </TitleCaption>
        <TwitterLink />
      </Top>
      {evolucionPorLista && ( // TODO loader
        <ListVotesPerElectionTable
          circumscriptionId={circumscriptionId}
          communeId={communeId}
          evolucionPorLista={evolucionPorLista}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: ${spaces.m} 0;
  gap: ${spaces.s};
`

const Top = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: ${spaces.xxs};
  margin-bottom: ${spaces.m};
`

export default ListVotesPerElectionSection
